const e="atlaskit",a=[{name:"Atlaskit",key:"atlaskit"},{name:"Material Design",key:"material-design"},{name:"Bootstrap",key:"bootstrap"},{name:"Font Awesome",key:"font-awesome"}];export{e as DEFAULT_PROVIDER,a as PROVIDERS};
